import React, {useState} from 'react';
import {Flex, Box} from 'reflexbox';
import FlightItinerary from '../FlightItinerary/FlightItinerary'

import './FlightTimes.scss';

export const renderLine = (line1, line2, line3, index, className) => {
  return (<Flex width={[1.0]} key={index} className={className}>
    <Box className={"left " + (line1.className !== undefined ? line1.className : '')} width={[line1.width]}>{line1.content}</Box>
    {
      line2.width === undefined ?
        (<Box className={"center " + (line2.className !== undefined ? line2.className : '')} flexGrow={1}>{line2.content}</Box>) :
        (<Box className={"center " + (line2.className !== undefined ? line2.className : '')} width={line2.width}>{line2.content}</Box>)
    }

    <Box className={"right " + (line3.className !== undefined ? line3.className : '')} width={[line3.width]}>{line3.content}</Box>
  </Flex>);
};


export default (props)=> {

  const [showDetails, setShowDetails] = useState(false);

  const firstFlight = props.flightDetails[0];
  const numberOfFlights = props.flightDetails.length;
  const lastFlight = props.flightDetails[numberOfFlights -1];
  const departureAirport = firstFlight.departure.airport;
  const departureTime = new Date(firstFlight.departure.time);
  const arrivalTime = new Date(lastFlight.arrival.time);
  const arrivalAirport = lastFlight.arrival.airport;

  const flightDetailsTitle = numberOfFlights > 1 ? ((numberOfFlights -1) + ' Stopp' + (numberOfFlights > 2 ? 's': '')) : 'Direktflug';
  const timeFormat = {hour: '2-digit', minute:'2-digit', timeZone: 'europe/berlin' };

  return (
    <div>
      <Flex className="FlightTimes" flexDirection="column">
        {renderLine(
          {width: 0.2, content: departureTime.toLocaleDateString("de-DE", {weekday:"short",day:"2-digit",month:"2-digit"})},
          {content: null},
          {width: 0.2, content: arrivalTime.toLocaleDateString("de-DE", {weekday:"short",day:"2-digit",month:"2-digit"})}
        )}
        {renderLine(
          {width: 0.2, content: (<div className="large-time">{departureTime.toLocaleTimeString("de-DE", timeFormat)}</div>)},
        {content: (<svg id="arrrow" width="175" height="11" viewBox="0 0 175 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="5" x2="169" y2="5" stroke="#BFCADE" strokeWidth="2"/>
            <path d="M174.996 5.00088L169.006 9.33709L168.998 0.675309L174.996 5.00088Z" fill="#BFCADE"/>
          </svg>)},
        {width: 0.2, content: (<div className="large-time">{arrivalTime.toLocaleTimeString("de-DE", timeFormat)}</div>)}
        )}
        {renderLine(
        {width: 0.3, content: (<div>{departureAirport.name} {departureAirport.code}</div>)},
        {content: (<div onClick={()=>{setShowDetails(!showDetails)}}>{flightDetailsTitle} <span className={"icon icon-arrow-bold-down" + (showDetails ? " up" : "")}></span></div>)},
        {width: 0.3, content: (<div>{arrivalAirport.name} ({arrivalAirport.code})</div>)}
        )}
      </Flex>
      {showDetails ? <FlightItinerary flightDetails = {props.flightDetails} /> : (null)}

    </div>)
}
